
import Template from "./template";

export default class Button {
    contstructor() {
        this.button = "";
    }

    bindEvents() {
        document.addEventListener("click", e => this.clickHandler(e));
    }

    removeActiveLinks() {
        if (this.button) {
            document.querySelectorAll(".button").forEach(el => {
                if (el.classList.contains("active")) {
                    el.classList.remove("active");
                }
            });
        }
    }

    clickHandler(e) {
        if (e.target.innerText === "3x3 shuffle") {
            this.callCanvas(375, 375, 3);
            this.removeActiveLinks();
            e.target.classList.add("active");
        }
        if (e.target.innerText === "4x4 shuffle") {
            this.callCanvas(375, 375, 4);
            this.removeActiveLinks();
            e.target.classList.add("active");
        }
        if (e.target.innerText === "5x5 shuffle" && this.button) {
            this.callCanvas(375, 375, 5);
            this.removeActiveLinks();
            e.target.classList.add("active");
        }
        if (e.target.innerText === "6x6 shuffle") {
            this.callCanvas(375, 375, 6);
            this.removeActiveLinks();
            e.target.classList.add("active");
        }
        if (e.target.innerText === "7x7 shuffle") {
            this.callCanvas(375, 375, 7);
            this.removeActiveLinks();
            e.target.classList.add("active");
        }
        if (e.target.innerText === "8x8 shuffle") {
            this.callCanvas(375, 375, 8);
            this.removeActiveLinks();
            e.target.classList.add("active");
        }
    }

    callCanvas(w, h, s) {
        if (this.button) {
            let puzzle = new Template(w, h, s);
            document.querySelector("#canvas").remove();
            puzzle.render();
        }
    }

    renderButtons() {
        const wrapper = document.createElement("div");
        wrapper.classList.add("button-wrapper");
        document.body.append(wrapper);
        for (let i = 0; i < 6; i += 1) {
            this.button = document.createElement("button");
            this.button.classList.add("button");
            wrapper.append(this.button);
            if (i === 0) {
                this.button.innerText = "3x3 shuffle";
            }
            if (i === 1) {
                this.button.innerText = "4x4 shuffle";
                this.button.classList.add("active");
            }
            if (i === 2) {
                this.button.innerText = "5x5 shuffle";
            }
            if (i === 3) {
                this.button.innerText = "6x6 shuffle";
            }
            if (i === 4) {
                this.button.innerText = "7x7 shuffle";
            }
            if (i === 5) {
                this.button.innerText = "8x8 shuffle";
            }
        }
    }
}
